import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { format, differenceInSeconds } from 'date-fns';

const pattern = 'dd.MM.yyyy HH:mm:ss:SSS';

type TrackProps = {
  renderStartTime: string;
  renderEndTime: string;
  renderDuration: string;
  pageUrl: string;
};
const useTrackRenderDuration = (
  trackRenderDuration: ({
    renderStartTime,
    renderEndTime,
    renderDuration,
    pageUrl,
  }: TrackProps) => void,
  isLoading: boolean,
) => {
  const { asPath } = useRouter();
  const renderStartTime = useRef(new Date());

  useEffect(() => {
    if (!isLoading) {
      const renderEndTime = new Date();
      const renderDuration = differenceInSeconds(renderEndTime, renderStartTime.current);

      trackRenderDuration({
        renderStartTime: format(renderStartTime.current, pattern),
        renderEndTime: format(renderEndTime, pattern),
        renderDuration: `${renderDuration}_secs`,
        pageUrl: asPath,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
};

export default useTrackRenderDuration;
